<!-- <template>
  <div class="payment-method-grid text-center">
    <a v-for="gateway in gateways" @click="onGatewayClicked(gateway)" :key="gateway.id" class="  bg-color-ea px-2 pt-2">
      <div class="position-relative payment-method-img">
        <img class="tick-box" v-if="selectedGateway && gateway.name === selectedGateway.name" :src="require('@/assets/images/tick-box.svg')" alt="tick">
        <img :src="gateway.image" :alt="gateway.name">
      </div>
      <h6 class="fontsize-small text-color-666 my-2">درگاه {{ gateway.label }}</h6>
    </a>
  </div>
</template>

<script>
export default {
  name: "Gateways",
  props: {
    selectedGateway: Object
  },
  computed: {
    gateways() {
      let homeData = this.$store.getters['front/getHomeData'];
      return homeData ? homeData.gateways : [];
    },
  },
  mounted() {
    this.$store.commit('front/addHomeRetrievedEvent', () => {
      if (!this.selectedGateway && this.gateways.length) {
        this.onGatewayClicked(this.gateways[0])
      }
    })
  },
  methods: {
    onGatewayClicked(gateway) {
      this.$emit('gatewaySelected', gateway)
    }
  }
}
</script>

<style scoped>
  .tick-box {
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style> -->

<template>
  <div>
    <div v-if="allGateways && allGateways.length">
      <div v-if="lodingSnappay" class="payment-grid payment-grid-Skeleton">
        <skeleton class="w-100 Skeleton" v-for="i in 4" :key="i"></skeleton>
      </div>

      <form v-else>
        <div class="payment-grid">
          <template v-for="(gateway, index) in allGateways">
            <label
              :key="gateway.id ? gateway.id : index"
              v-if="gateway.name != 'snapppay'"
              :for="`snapChecked-${index}`"
              class="d-flex align-items-center mt-3"
              style="gap: 6px"
            >
              <input
                type="radio"
                :id="`snapChecked-${index}`"
                name="CheckedGateway"
                :value="gateway"
                v-model="selectedValue"
                :checked="
                  selectedValue && gateway && selectedValue.name == gateway.name
                    ? true
                    : false
                "
                @change="updateSelectedObject"
                :disabled="lodingSnappayWalet && gateway.name == 'snapppay'"
              />

              <picture
                :class="{
                  activeBankSnapPay:
                    selectedGateway && gateway.name === selectedGateway.name,
                  disabledBtn:
                    lodingSnappayWalet &&
                    snapPayValue &&
                    snapPayValue.name == 'snapppay',
                }"
                class="box bg-color-ea snapppay-payment-method-img m-0"
              >
                <source media="(max-width:648px)" :srcset="gateway.image" />
                <img :src="gateway.image" :alt="gateway.name" />
              </picture>
              <p class="description-snapPay">
                <span class="fontsize-small text-color-666 my-2">
                  {{ gateway.label }}</span
                >
              </p>
            </label>

            <label
              :key="gateway.id ? gateway.id : index"
              v-if="
                gateway.name == 'snapppay' && snapPayValue && !disablePayWallet
              "
              :for="`snapChecked-${index}`"
              class="d-flex align-items-center mt-3"
              style="gap: 6px"
            >
              <input
                type="radio"
                :id="`snapChecked-${index}`"
                name="CheckedGateway"
                :value="snapPayValue"
                v-model="selectedValue"
                :checked="
                  selectedValue &&
                  snapPayValue &&
                  selectedValue.name == snapPayValue.name
                    ? true
                    : false
                "
                @change="updateSelectedObject"
                :disabled="
                  lodingSnappayWalet &&
                    snapPayValue &&
                    snapPayValue.name == 'snapppay'
                "
              />

              <picture
                v-if="snapPayValue"
                :class="{
                  activeBankSnapPay:
                    selectedGateway &&
                    snapPayValue &&
                    snapPayValue.name === selectedGateway.name,
                  disabledBtn:
                    lodingSnappayWalet &&
                    snapPayValue &&
                    snapPayValue.name == 'snapppay',
                }"
                class="box bg-color-ea snapppay-payment-method-img-logo m-0"
              >
                <source
                  media="(max-width:648px)"
                  srcset="@/assets/images/SnappPay65.png"
                />
                <img src="@/assets/images/SnappPay70.png" />
              </picture>
              <p class="description-snapPay">
                <span class="fontsize-small font-weight-bold my-2">
                  {{ snapPayValue.label }}</span
                >
                <span class="fontsize-small text-color-666 my-2">
                  {{ snapPayValue.description }}</span
                >
              </p>
            </label>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import skeleton from "./skeleton.vue";
export default {
  name: "Gateways",
  components: {
    skeleton,
  },
  props: {
    selectedGateway: Object,
    snapPayValue: Object,
    lodingSnappayWalet: Boolean,
    lodingSnappay: Boolean,
    disablePayWallet: Boolean,
  },
  data() {
    return {
      selectedValue: null,
      // selectedValue: this.snapPayValue ? this.snapPayValue : null,
      selectedObject: null,
    };
  },
  computed: {
    allGateways() {
      let homeData = this.$store.getters["front/getHomeData"];
      return homeData ? homeData.gateways : [];
    },
  },
  mounted() {
    this.$store.commit("front/addHomeRetrievedEvent", () => {
      if (this.allGateways && this.allGateways.length) {
        this.selectedValue = this.allGateways[0];
        this.updateSelectedObject();
      }
    });
  },

  watch: {
    // snapPayValue: {
    //   handler(newOptions) {
    //     this.selectedValue = newOptions; // دقیقاً همون reference
    //   },
    //   immediate: true, // این باعث میشه همون لحظه‌ای که component mount میشه هم اجرا بشه
    // },
  },
  methods: {
    // onGatewayClicked(gateway) {
    //   // console.log(gateway, "gatewaygatewaygatewaygateway");
    //   this.selectedValue = null;
    //   this.$emit("gatewaySelected", gateway);
    // },
    updateSelectedObject() {
      this.$emit("gatewaySelected", this.selectedValue);
    },
  },
};
</script>

<style scoped>
.Skeleton {
  height: 80px;
}

.payment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.payment-grid .box {
  border-radius: 15px;
  overflow: hidden;
  background-color: transparent;
}

.payment-grid-Skeleton {
  gap: 10px;
}

.snapppay-payment-method-img {
  min-width: 75px;
  min-height: 75px;
  width: 75px;
  height: 75px;
}

.description-snapPay {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
}

.description-snapPay span {
  margin: 0 !important;
  font-size: 14px;
  text-align: right;
  white-space: nowrap;
}

.snapppay-payment-method-img img {
  width: 100%;
  height: 100%;
}

.payment-grid input {
  accent-color: #15cdb7;
  width: 16px;
  height: 16px;
  -webkit-appearance: auto;
  appearance: auto;
}

.payment-grid label {
  cursor: pointer;
}

@media screen and (max-width: 1240px) {
  .payment-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }

  .payment-method-img {
    height: 70px;
  }
}

@media screen and (max-width: 648px) {
  .payment-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 8px;
  }

  .payment-method-img {
    height: 70px;
  }

  .snapppay-payment-method-img {
    width: 65px;
    height: 65px;
    min-width: 65px;
    min-height: 65px;
  }

  .description-snapPay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
  }

  .description-snapPay span {
    margin: 0 !important;
    font-size: 14px;
  }
}

.filter-grayscale1 {
  filter: grayscale(1);
}

.activeBank {
  filter: grayscale(0) !important;
}

.activeBank .payment-method-img {
  border: 1px solid var(--color-theme);
  border-radius: 15px;
  padding: 6px;
}

.tick-box {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.disabledBtn * {
  color: #fff;
}
</style>
